import { call, put } from 'redux-saga/effects';
import GetAppointmentTimeslotsNewActions from '../redux/GetAppointmentTimeslotsNewRedux';
import { api } from './api';


export function* getAppointmentTimeslotsNew(action: any): Generator<any, void, any> {
  const { children_id } = action
  // get current data from Store
  // const currentData = yield select(GetAppointmentTimeslotsSelectors.getData)
  // make the call to the api
  const response = yield call(api.getAppointmentTimeslotsNew, children_id)

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetAppointmentTimeslotsNewActions.getAppointmentTimeslotsNewSuccess(response?.data?.data))
  } else {
    yield put(GetAppointmentTimeslotsNewActions.getAppointmentTimeslotsNewFailure())
  }
}